<script setup>
// import { ref } from 'vue';
import SalaryPendingTable from "./Tables/SalaryPendingTable.vue";
import SalaryTable from "./Tables/SalaryTable.vue";
import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import ArgonRadio from "@/components/ArgonRadio.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Salary</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Employee</label>
                            <select class="form-control" v-model="model.salary.empcode">
                                <option v-for="(item,index) in employeeList" :key="index" :value="item.empcode">
                                    {{ item.empcode }} - {{ item.race_desc }} - {{ item.name }} 
                                </option>
                            </select>
                        </div>
                        <div class="col-md-4">
                            <label for="example-text-input" class="form-control-label text-danger">Period</label>
                            <div class="d-flex align-items-center">
                                <argon-radio id="FullDay" name="batch-type" class="me-3" :checked="model.salary.period === 0" @click="model.salary.period = 0">Full Day</argon-radio>
                                <argon-radio id="Morning" name="batch-type" class="me-3" :checked="model.salary.period === 1" @click="model.salary.period = 1">Morning</argon-radio>
                                <argon-radio id="Afternoon" name="batch-type" :checked="model.salary.period === 2" @click="model.salary.period = 2">Afternoon</argon-radio>
                            </div>
                        </div>
                        <div class="col-md-2" >
                            <label for="example-text-input" class="form-control-label text-danger">Date</label>
                            <input class="form-control" v-model="model.salary.date" id="input_date" type="date" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Status</label>
                            <select class="form-control" v-model="model.salary.status" >
                                <option value="0">Pending</option>
                                <option value="1">Paid</option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Type</label>
                            <select class="form-control" v-model="model.salary.type" @change="onChangeType">
                                <option value="0">Basic</option>
                                <option value="1">Luar</option>
                                <option value="2">Racun</option>
                                <option value="3">Other</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.salary.remark"  placeholder="Remark...." />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2" >
                            <label for="example-text-input" class="form-control-label text-danger">Basic </label>
                            <label v-show="model.salary.type == 1" for="example-text-input" class="form-control-label text-danger">Luar </label>
                            <label v-show="model.salary.type == 2" for="example-text-input" class="form-control-label text-danger">Racun </label>
                            <label for="example-text-input" class="form-control-label text-danger">(RM/Hour)</label> 
                            <input class="form-control" v-model="model.salary.basic" id="input_basic" min="0" type="number" placeholder="Basic..." />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Hour</label>
                            <input class="form-control" v-model="model.salary.hour" id="input_hour" min="0" type="number" />
                        </div>
                        <div class="col-md-2" >
                            <label for="example-text-input" class="form-control-label">OT </label>
                            <label v-show="model.salary.type == 1" for="example-text-input" class="form-control-label">Luar </label>
                            <label v-show="model.salary.type == 2" for="example-text-input" class="form-control-label">Racun </label>
                            <label for="example-text-input" class="form-control-label">(RM/Hour)</label> 
                            <input class="form-control" v-model="model.salary.ot" id="input_ot" min="0" type="number" placeholder="OT..." />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">OT Hour</label>
                            <input class="form-control" v-model="model.salary.ot_hour" id="input_ot_hour" min="0" type="number" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Deduct</label>
                            <input class="form-control" v-model="model.salary.deduct" id="input_deduct" min="0" type="number" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Sub Total (RM) <i class="fas fa-info-circle text-dark text-sm opacity-10" title="Basic + OT"></i></label>
                            <input class="form-control" v-model="model.salary.subtotal" id="input_sub_total" type="number" disabled />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Duit Makan</label>
                            <input class="form-control" v-model="model.salary.duitmakan" id="input_duitmakan" min="0" type="number" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Bonus/Allowance</label>
                            <input class="form-control" v-model="model.salary.bonus" id="input_bonus" min="0" type="number" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Socso(%)</label>
                            <input class="form-control" v-model="model.salary.socso_rate" id="input_socso" min="0" type="number" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">EPF(%)</label>
                            <input class="form-control" v-model="model.salary.epf_rate" id="input_epf" min="0" type="number" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" :title="model.description" class="form-control-label">Grand Total (RM) <i class="fas fa-info-circle text-dark text-sm opacity-10" ></i></label>
                            <input class="form-control" v-model="model.salary.total" id="input_total" type="number" disabled />
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success mt-3" @click="addSalary" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="mt-4 row">
        <div class="col-12">
            <SalaryPendingTable :key="componentKey" />
        </div>
    </div>
    <div class="mt-4 row">
        <div class="col-12">
            <SalaryTable :key="componentKey" />
        </div>
    </div>
</div>

</template>


<script>
import axios from 'axios';
export default {
  name:'SalaryCreate',
  data(){
    return {
        employeeList:[],
        componentKey: 0,
    //   errorList: '',
      model:{
        salary:{
            empcode:'',
            period:0,
            remark:'',
            date: new Date().toISOString().slice(0,10),
            type:0,
            basic:0,
            total: 0,
            ot:0,
            hour: 1,
            ot_hour:0,
            epf:0,
            epf_rate:0,
            socso:0,
            socso_rate:0,
            bonus:0,
            duitmakan:0,
            subtotal:0,
            status:0,
            deduct:0
        },
        description:'Calculation: (basic + OT) - ((basic + OT)*Socso/100) - ((basic + OT)*EPF/100) + Bonus + Duit Makan'
      },
    }
  },
  watch: {
    'model.salary.hour': 'updateTotal',
    'model.salary.ot_hour': 'updateTotal',
    'model.salary.basic': 'updateTotal',
    'model.salary.ot': 'updateTotal',
    'model.salary.epf_rate': 'updateTotal',
    'model.salary.socso_rate': 'updateTotal',
    'model.salary.bonus': 'updateTotal',
    'model.salary.duitmakan': 'updateTotal',
    'model.salary.deduct': 'updateTotal'
  },
  mounted(){
    this.listAllEmployee();
  },
  methods: {
    updateTotal() {
        let basic = parseFloat(this.model.salary.basic) || 0;

        let ot = parseFloat(this.model.salary.ot) || 0;

        let hour = parseFloat(this.model.salary.hour) || 0;
        let ot_hour = parseFloat(this.model.salary.ot_hour) || 0;

        let sub_total = ((basic * hour) + (ot * ot_hour) - this.model.salary.deduct).toFixed(2);
        let bonus = this.model.salary.bonus + this.model.salary.duitmakan;
        let socso = sub_total * ((parseFloat(this.model.salary.socso_rate) || 0)/100);
        let epf = sub_total * ((parseFloat(this.model.salary.epf_rate) || 0)/100);

        this.model.salary.socso = socso;
        this.model.salary.epf = epf;
        this.model.salary.subtotal= sub_total;
        this.model.salary.total = (sub_total - socso - epf + bonus).toFixed(2);
        this.model.description = "Calculation: (basic + OT - Deduct) - ((basic + OT)*Socso/100) - ((basic + OT)*EPF/100) + Bonus + Duit Makan \nRM " + sub_total+ 
        " (Basic + OT - Deduct) - RM " + socso.toFixed(2) + 
        " (Socso) - RM " + epf.toFixed(2) + " (EPF) + RM " + bonus.toFixed(2) + " (Bonus + Duit Makan)" ;
    },
    onChangeType(){
        let empcode = this.model.salary.empcode;
        if(this.model.salary.type == 0){
            this.model.salary.basic = (this.employeeList.find(e => e.empcode === empcode) || {}).basic || 0;
            this.model.salary.ot = (this.employeeList.find(e => e.empcode === empcode) || {}).ot || 0;
        }
        if(this.model.salary.type == 3){
            this.model.salary.basic = 0;
            this.model.salary.ot = (this.employeeList.find(e => e.empcode === empcode) || {}).ot || 0;
        }
        if(this.model.salary.type == 1){
            this.model.salary.basic = (this.employeeList.find(e => e.empcode === empcode) || {}).luar || 0;
            this.model.salary.ot = (this.employeeList.find(e => e.empcode === empcode) || {}).ot_luar || 0;
        }
        if(this.model.salary.type == 2){
            this.model.salary.basic = (this.employeeList.find(e => e.empcode === empcode) || {}).racun || 0;
            this.model.salary.ot = (this.employeeList.find(e => e.empcode === empcode) || {}).ot_racun || 0;
        }
    },
    addSalary(){
        // if(this.model.salary.ot_hour <= 0){
        //     this.model.salary.ot = 0;
        // }
        axios.post('payroll/addSalary',this.model.salary)
            .then(res => {
                alert(res.data.message);
                this.model.salary = {
                    empcode: '',
                    period:0,
                    remark:'',
                    date: new Date().toISOString().slice(0,10),
                    type:0,
                    basic:0,
                    total: 0,
                    ot:0,
                    hour: 1,
                    ot_hour:0,
                    epf:0,
                    epf_rate:0,
                    socso:0,
                    socso_rate:0,
                    bonus:0,
                    duitmakan:0,
                    subtotal:0,
                    status:0,
                    deduct:0,
                };
                this.model.salary.empcode = this.employeeList[0].empcode;
                this.model.salary.basic = this.employeeList[0].basic;
                this.model.salary.ot = this.employeeList[0].ot;
                this.model.salary.epf_rate = this.employeeList[0].epf || 0;
                this.model.salary.socso_rate = this.employeeList[0].socso || 0;
                this.componentKey += 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Vehicle No and type is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
        
    },
    listAllEmployee(){
        axios.get('payroll/listAllEmployee')
            .then(res => {
              this.employeeList = res.data.employeeList;
              this.model.salary.empcode = res.data.employeeList[0].empcode;
              this.model.salary.basic = res.data.employeeList[0].basic;
              this.model.salary.ot = res.data.employeeList[0].ot;
              this.model.salary.epf_rate = res.data.employeeList[0].epf || 0;
              this.model.salary.socso_rate = res.data.employeeList[0].socso || 0;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    },
    
  },
}
</script>
